var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"stk-box-loader"},[_c(_setup.LoaderWithText,[_vm._v("\n    Loading…\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }